import React from 'react';
import iconSprite from '../assets/icons/material-icons.svg';

const Icon = ({ name, size = 18, color, style = {} }: { name: string; size?: number; color?: string; style?: React.CSSProperties }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    style={{
      display: 'inline-block',
      color: color || 'inherit',
      userSelect: 'none',
      flexShrink: 0,
      ...style,
    }}
  >
    <use href={`${iconSprite}#${name}`} xlinkHref={`${iconSprite}#${name}`} />
  </svg>
);

export default Icon;

